'use strict';
var core        = require(43)
  , $           = require(65)
  , DESCRIPTORS = require(46)
  , SPECIES     = require(88)('species');

module.exports = function(KEY){
  var C = core[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};